import { useNavigate } from "react-router-dom";
import { newImageUrl } from "../../pages/Manufacturers/ManufactureProfile";
import defaultImage from "../../assets/svg/defultImage.svg";
import { Add } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { Modal } from "react-bootstrap";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export const VanCard = ({
  van,
  selectVanModal,
  handleSelection,
  handleUpdateVehicle,
  getVanList
}) => {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  // get satff

  const getStaffByRole = (slug) => {
    const staff = van?.current_stuff?.find(
      (staff) => staff?.job_title?.slug === slug
    );
    return staff;
  };

  // get supervisors

  const [supervisors, setSupervisors] = useState([]);

  const getSupervisors = async () => {
    try {
      let response = await axios.get(`${newBaseUrl}/api/portal/operators`, {
        headers,
      });
      const operators = response.data.data.operators;
      const supervisors = operators.filter(
        (operator) =>
          Array.isArray(operator.roles) && operator.roles.includes("supervisor")
      );
      setSupervisors(supervisors);
    } catch (error) {
      console.log(error);
    }
  };

  // assign supervisor to vehicle

  const [show, setShow] = useState(false);

  const [supervisorId, setSupervisorId] = useState(null);

  const [vanId, setVanId] = useState(null);

  const handleShow = (id) => {
    setShow(true);
    setVanId(id);
  };

  const handleClose = () => {
    setShow(false);
    setVanId(null);
    setSupervisorId(null);
  };

  const handleSubmitnotify = async () => {
    const formData = new FormData();

    formData.append("supervisor_id", supervisorId);

    formData.append("vehicle_id", vanId);

    const url = `${newBaseUrl}/api/portal/vehicle_supervisor_assignment/assign`;

    try {
      const response = await axios.post(url, formData, { headers });
      console.log(response);
      toast.success(response.data.data.message, { autoClose: 3000 });
      handleClose();
      getVanList()
      // getPoints();
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message, { autoClose: 3000 });
    }
  };

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm();

  // navigation for profile

  const navigate = useNavigate();

  const goToVanProfile = (id) => {
    if (!selectVanModal) {
      navigate(`/vehicles/${id}`);
    }
  };

  // effects

  useEffect(() => {
    getSupervisors();
  }, []);

  return (
    <>
      {/* add supervisor to vehicle */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            Assign Supervisor
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(handleSubmitnotify)}>
            <div className="col-10 mx-auto">
              <FormControl className="w-100 mt-1" variant="outlined">
                <InputLabel id="supervisor-label">Supervisor</InputLabel>
                <Select
                  labelId="supervisor-label"
                  label="Supervisor"
                  // multiple
                  onChange={(e) => {
                    setSupervisorId(e.target.value);
                  }}
                >
                  {supervisors.map((sup) => (
                    <MenuItem
                      className="custom-menu-item"
                      key={sup.id}
                      value={sup.id}
                    >
                      {sup.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <div
        id={van?.id}
        onClick={() => selectVanModal && handleSelection(van.id)}
        className={`col-12 col-lg-3 col-md-6 ${selectVanModal && "stuff-card"}`}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
            goToVanProfile(van?.id);
          }}
          key={van?.id}
          className="rounded-2 p-3 bg-light my-2 cursor"
          style={{
            overflow: "hidden",
            height: "480px",
            minHeight: "480px",
            maxHeight: "480px",

            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* van name */}
          <h6
            className="fs-6 fw-bold"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            Van # {van?.id}
          </h6>
          {/* van model & logo */}
          <div
            style={{ height: "30px" }}
            className="d-flex justify-content-between align-items-center gap-1"
          >
            <div className=" d-flex gap-1">
              <img
                style={{ width: 20 }}
                src={
                  van?.model?.brand?.logo_path
                    ? `${newImageUrl}${van?.model?.brand?.logo_path}`
                    : defaultImage
                }
                alt="brand-image"
              />
              <p
                className="m-0 small"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "120px",
                }}
              >
                {van?.model?.name}
              </p>
            </div>
            <p className=" fw-semibold my-0"># { van?.id}</p>
          </div>
          {/* van image */}
          <div
            className="d-flex justify-content-center align-items-center rounded-3 my-2 overflow-hidden"
            style={{
              height: "180px",
              minHeight: "180px",
              maxHeight: "180px",
              width: "100%",
              flexShrink: 0,
            }}
          >
            <img
              className="rounded-3"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                backgroundColor: "#f7f7f7",
                flexShrink: 0,
              }}
              src={
                van?.profile_photo_url
                  ? `${newImageUrl}${van?.profile_photo_url}`
                  : defaultImage
              }
              alt="van-image"
            />
          </div>
          {/* van details */}
          <div
            style={{
              flex: "1 0 auto",
              minHeight: "220px",
              maxHeight: "220px",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* Van Capacity */}
            <div className="upload-file-responsive">
              <h6 className="main-text-color label-van m-0">Van Capacity</h6>
              <div className="progress my-1" style={{ height: "10px" }}>
                <div
                  className={
                    van?.capacity > 7 && van?.capacity <= 10
                      ? "bg-success"
                      : van?.capacity > 3 && van?.capacity < 7
                        ? "bg-warning"
                        : van?.capacity === 0
                          ? "bg-transparent"
                          : van?.capacity > 0 && van?.capacity < 3
                            ? "bg-danger"
                            : ""
                  }
                  role="progressbar"
                  style={{
                    width:
                      van?.capacity === 10
                        ? "100%"
                        : van?.capacity > 7
                          ? "90%"
                          : van?.capacity > 3 && van?.capacity < 7
                            ? "50%"
                            : van?.capacity > 0 && van?.capacity < 3
                              ? "30%"
                              : van?.capacity === 0
                                ? "0%"
                                : "",
                  }}
                  aria-valuenow={van?.capacity}
                  aria-valuemin="0"
                  aria-valuemax="10"
                ></div>
              </div>
            </div>
            {/* Working Hours */}
            <div className="upload-file-responsive mt-2">
              <h6 className="main-text-color label-van m-0">Working hours</h6>

              <div className="progress my-1" style={{ height: "10px" }}>
                <div
                  className={
                    van?.worked_hours > 7 && van?.worked_hours <= 10
                      ? "bg-success"
                      : van?.worked_hours > 3 && van?.worked_hours < 7
                        ? "bg-warning"
                        : van?.worked_hours === 0
                          ? "bg-transparent"
                          : van?.worked_hours > 0 && van?.worked_hours < 3
                            ? "bg-danger"
                            : ""
                  }
                  role="progressbar"
                  style={{
                    width:
                      van?.worked_hours === 10
                        ? "100%"
                        : van?.worked_hours > 7
                          ? "90%"
                          : van?.worked_hours > 3 && van?.worked_hours < 7
                            ? "50%"
                            : van?.worked_hours > 0 && van?.worked_hours < 3
                              ? "30%"
                              : van?.worked_hours === 0
                                ? "0%"
                                : "",
                  }}
                  aria-valuenow={van?.worked_hours}
                  aria-valuemin="0"
                  aria-valuemax="10"
                ></div>
              </div>
            </div>
            {/* Services Categories */}
            {/* <div className="d-flex custom-card-sm justify-content-between align-items-center mt-3">
              <h6 className="main-text-color label-van m-0">
                Services Categories
              </h6>
              <div className="">
                {van.service_categories?.length > 0 ? (
                  <>
                    {van.service_categories.map((service) => (
                      <img
                        className="service-icon"
                        src={newImageUrl + service.icon_url}
                        alt="service-icon"
                      />
                    ))}
                  </>
                ) : (
                  <div className="">
                    <p className="m-0 label-van">No Available Services</p>
                  </div>
                )}
              </div>
            </div> */}
            <div
              className="d-flex justify-content-between align-items-center custom-card-sm my-1"
              style={{
                height: "22px",
                minHeight: "22px",
                maxHeight: "22px",
              }}
            >
              <h6 className="main-text-color label-van m-0">
                Services Categories
              </h6>

              <div className="d-flex align-items-center service-icons-wrapper">
                {van.service_categories?.length > 0 ? (
                  <>
                    {/* أول 4 Icons */}
                    {van.service_categories
                      .slice(0, 2)
                      .map((service, index) => (
                        <img
                          key={index}
                          className="service-icon"
                          src={newImageUrl + service.icon_url}
                          alt="service-icon"
                        />
                      ))}

                    {/* لو في زيادة */}
                    {van.service_categories.length > 2 && (
                      <div className="more-icons">
                        +{van.service_categories.length - 2}
                        {/* Tooltip */}
                        <div className="more-icons-tooltip">
                          {van.service_categories
                            .slice(2)
                            .map((service, index) => (
                              <img
                                key={index}
                                className="service-icon"
                                src={newImageUrl + service.icon_url}
                                alt="service-icon"
                              />
                            ))}
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <p className="m-0 label-van">No Available Services</p>
                )}
              </div>
            </div>

            {/* Supervisor */}
            <div
              className="d-flex justify-content-between align-items-center custom-card-sm"
              style={{
                height: "22px",
                minHeight: "22px",
                maxHeight: "22px",
              }}
            >
              <h6 className="main-text-color m-0 label-van">Supervisor</h6>
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "120px",
                }}
              >
                {van?.supervisor?.length > 0 ? (
                  van.supervisor.map((sup) => (
                    <h6 key={sup.id} className="m-0 label-van">
                      {sup.name}
                    </h6>
                  ))
                ) : (
                  <h6
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShow(van?.id);
                    }}
                    className="m-0 label-van"
                  >
                    Add Supervisor <Add sx={{ fontSize: "12px" }} />
                  </h6>
                )}
              </div>
            </div>
            {/* Agent */}
            <div
              className="d-flex justify-content-between align-items-center custom-card-sm"
              style={{
                height: "22px",
                minHeight: "22px",
                maxHeight: "22px",
              }}
            >
              <h6 className="main-text-color m-0 label-van">Agent</h6>
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "120px",
                }}
              >
                {van?.agent?.length > 0 ? (
                  van.agent.map((agent) => (
                    <h6 key={agent.id} className="m-0 label-van">
                      {agent.name}
                    </h6>
                  ))
                ) : (
                  <h6
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShow(van?.id);
                    }}
                    className="m-0 label-van"
                  >
                    Add Agent <Add sx={{ fontSize: "12px" }} />
                  </h6>
                )}
              </div>
            </div>
            {/* Driver */}
            <div
              className="d-flex justify-content-between align-items-center custom-card-sm"
              style={{
                height: "22px",
                minHeight: "22px",
                maxHeight: "22px",
              }}
            >
              <h6 className="main-text-color m-0 label-van">Driver</h6>
              <h6
                className="m-0 label-van"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "120px",
                }}
              >
                {getStaffByRole("driver")?.name || (
                  <button className="border-0 bg-transparent button-size">
                    Add Driver <Add sx={{ fontSize: "12px" }} />
                  </button>
                )}
              </h6>
            </div>
            {/* Engineer */}
            <div
              className="d-flex justify-content-between align-items-center custom-card-sm"
              style={{
                height: "22px",
                minHeight: "22px",
                maxHeight: "22px",
              }}
            >
              <h6 className="main-text-color m-0 label-van">Engineer</h6>
              <h6
                className="m-0 label-van"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "120px",
                }}
              >
                {getStaffByRole("engineer")?.name || (
                  <button className="border-0 bg-transparent button-size">
                    Add Engineer <Add sx={{ fontSize: "12px" }} />
                  </button>
                )}
              </h6>
            </div>
            {/* Technician */}
            <div
              className="d-flex justify-content-between align-items-center custom-card-sm"
              style={{
                height: "22px",
                minHeight: "22px",
                maxHeight: "22px",
              }}
            >
              <h6 className="main-text-color m-0 label-van">Technician</h6>
              <h6
                className="m-0 label-van"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "120px",
                }}
              >
                {getStaffByRole("technician")?.name || (
                  <button className="border-0 bg-transparent button-size">
                    Add Technician <Add sx={{ fontSize: "12px" }} />
                  </button>
                )}
              </h6>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
